import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import ApiPaginationDataTable from "../../../myComponents/DataTable/ApiPaginationDataTable";
import { getStudentResultAPI, getStudentResultLMSAPI } from "../../../api/LMS/master";
import useLogout from "../../../utils/Utils";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";
import { decrypt } from "../../../utils/Encrypt";
import { hasPermission } from "../../../utils/myFunctions";

const TestResult = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null,
      server_search: "",
    },
  });
  const location = useLocation();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const [timer, setTimer] = useState(5); // 5 seconds countdown
  useEffect(() => {
    if (!isView) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      // redirect to home page when the timer reaches 0
      if (timer === 0) {
        navigate(-1);
      }
      // clean up the interval when the component unmounts
      return () => clearInterval(interval);
    } else {
      setIsLoading(false);
    }
  }, [timer]);
  const { logout } = useLogout();
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [data, setData] = useState([]);
  const [classList, setClassList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [columns, setColumns] = useState([
    {
      name: "Session",
      selector: (row) => row?.session,
      cell: (row) => <span className="text-capitalize">{row?.session}</span>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Class",
      selector: (row) => row?.class,
      cell: (row) => <span className="text-capitalize">{row?.class}</span>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Stream",
      selector: (row) => row?.stream,
      sortable: true,
      wrap: true,
    },
    {
      name: "Subject",
      selector: (row) => row?.subject,
      sortable: true,
      wrap: true,
    },
    {
      name: "Chapter",
      selector: (row) => row?.chapter,
      sortable: true,
      wrap: true,
    },
    {
      name: "Learner ID",
      selector: (row) => row?.learner_id,
      cell: (row) => <span className="text-capitalize">{row?.learner_id}</span>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Test Name",
      selector: (row) => row?.test_name,
      cell: (row) => <span className="text-capitalize">{row?.test_name}</span>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Score",
      selector: (row) => row?.score,
      cell: (row) => <span className="text-capitalize">{row?.score}</span>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleView(row)}>
            {" "}
            <Icon name="eye" />
          </Button>
        </div>
      ),
    },
    // {
    //   name: "Correct Answer",
    //   selector: (row) => row?.correct_answer,
    //   cell: (row) => <span className="text-capitalize">{row?.correct_answer}</span>,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "Wrong Answer",
    //   selector: (row) => row?.wrong_answer,
    //   cell: (row) => <span className="text-capitalize">{row?.wrong_answer}</span>,
    //   sortable: true,
    //   wrap: true,
    // },
  ]);
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(50);
  // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
  };
  const handlePageChange = (page) => {
    setValue("page", page);
  };
  const handleView = (row) => {
    navigate("/student-result", { state: row });
    console.log("Row", row);
  };
  useEffect(() => {
    if (watch("server_search")?.length == 0) {
      handleSearch(perPage);
    }
  }, [watch("page"), perPage, watch("server_search")]);
  const handleSearch = (data) => {
    console.log("data", data);
    const payload = {
      ...(user?.role == "Subject Specialist" ? { class_id: user?.class_id } : { class_id: watch("class")?.value }),
      ...(user?.role == "Subject Specialist"
        ? { subject_id: user?.subject_id }
        : { subject_id: watch("subject")?.value }),
      ...(user?.role == "Subject Specialist" ? { stream_id: user?.stream_id } : { stream_id: watch("stream")?.value }),

      session: watch("session")?.value || "",
      // class_id: watch("class")?.value||"",
      // subject_id: watch("subject")?.value||"",
      chapter_id: watch("chapter")?.value || "",
      limit: perPage,
      page: watch("page") || 1,
    };
    setIsLoading(true);
    getStudentResultLMSAPI(payload)
      .then((res) => {
        const status = res.data.status;
        if (status) {
          setTotalRows(res.data.data.pagination.total);
          setData(res.data.data.tableData);
          setIsLoading(false);
        } else if (!status) {
          setData([]);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Err", err);
      });
  };
  const serverSideSearch = (data) => {
    const body = {
      search: data,
    };
    // return;
    getStudentResultLMSAPI(body)
      .then((res) => {
        const status = res.data.status;
        if (status) {
          setIsLoading(false);
          setData(res.data.data.tableData);
        } else if (!status) {
          setIsLoading(false);
          setData([]);
        } else if (status === "expired") {
          setIsLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("catch error", err);
      });
  };
  return (
    <>
      <Head title={"Result"} />
      <Content>
        {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) : (
          <>
            <BlockHead size={`sm`}>
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page tag="h3">
                    {"Result"}
                  </BlockTitle>
                </BlockHeadContent>
                {/* <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen(!isOpen);
                    setMode("Add");
                    reset();
                  }}
                >
                  {<Icon name={isOpen ? "minus" : "plus"} />}
                </Button>
              </div>
            </BlockHeadContent> */}
              </BlockBetween>
            </BlockHead>
            <Block>
              <ApiPaginationDataTable
                columns={columns}
                data={data}
                isLoading={isLoading}
                search
                register={register}
                trigger={trigger}
                watch={watch}
                setValue={setValue}
                title={"Test Result"}
                errors={errors}
                handleSubmit={handleSubmit}
                handleSearch={handleSearch}
                serverSearch
                serverSideSearch={serverSideSearch}
                session
                Class
                subject
                subjectReq
                chapter
                chapterReq
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                totalRows={totalRows}
                perPage={perPage}
                stream
              />
            </Block>
          </>
        )}
      </Content>
    </>
  );
};

export default TestResult;
